import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';

import { ItemsResponseDto } from '@platform/shared/items-response.dto';
import { PostProjectDto, PostProjectUserDto, ProjectAdminDto, ProjectDto } from './projects.model';

@Injectable({
  providedIn: 'root',
})
export class ProjectsService {
  constructor(private http: HttpClient) {}

  public getProjects(): Observable<ProjectDto[]> {
    return this.http.get<ProjectDto[]>(`${environment.apiUrl}/projects`);
  }

  public getCustomerSpaceProjectsForList(customerSpaceId: string): Observable<ProjectDto[]> {
    return this.http.get<ProjectDto[]>(`${environment.apiUrl}/customer-spaces/${customerSpaceId}/projects/for-list`);
  }

  public getCustomerSpaceProjectsForWidget(customerSpaceId: string, top?: number) {
    let params = new HttpParams();

    if (top) {
      params = params.set('top', top.toString());
    }

    const options = params.keys().length > 0 ? { params } : {};
    return this.http.get<ItemsResponseDto<ProjectDto>>(
      `${environment.apiUrl}/customer-spaces/${customerSpaceId}/projects/for-widget`,
      options,
    );
  }

  public getProjectAdmin(customerSpaceId: string, projectId: string): Observable<ProjectAdminDto> {
    return this.http.get<ProjectAdminDto>(`${environment.apiUrl}/customer-spaces/${customerSpaceId}/projects/${projectId}/admin`);
  }

  public createProject(customerSpaceId: string, project: PostProjectDto): Observable<ProjectAdminDto> {
    return this.http.post<ProjectAdminDto>(`${environment.apiUrl}/customer-spaces/${customerSpaceId}/projects`, project);
  }

  public updateProject(customerSpaceId: string, projectId: string, project: PostProjectDto): Observable<ProjectAdminDto> {
    return this.http.put<ProjectAdminDto>(`${environment.apiUrl}/customer-spaces/${customerSpaceId}/projects/${projectId}`, project);
  }

  public deleteProject(customerSpaceId: string, projectId: string): Observable<object> {
    return this.http.delete(`${environment.apiUrl}/customer-spaces/${customerSpaceId}/projects/${projectId}`);
  }

  public removeProjectUser(customerSpaceId: string, projectId: string, userId: string): Observable<ProjectAdminDto> {
    return this.http.delete<ProjectAdminDto>(
      `${environment.apiUrl}/customer-spaces/${customerSpaceId}/projects/${projectId}/users/${userId}`,
    );
  }

  public updateProjectUser(customerSpaceId: string, projectId: string, postProjectUser: PostProjectUserDto): Observable<ProjectAdminDto> {
    return this.http.post<ProjectAdminDto>(
      `${environment.apiUrl}/customer-spaces/${customerSpaceId}/projects/${projectId}/users`,
      postProjectUser,
    );
  }
}
